import { all, call, put, takeLatest } from "redux-saga/effects";

import { SCREEN } from "helper/roleChecker/Screens";
import {
  getDocsDetailFailed,
  getDocsDetailStart,
  getDocsDetailSuccess,
} from "../redux/getDetail";
import { getInternalDocumentDetailAPI } from "core/http/service/internalDocument";

function* getDocsDetailWork(action) {
  const payload = action.payload;
  try {
    const res = yield call(getInternalDocumentDetailAPI, {
      screenCode: SCREEN.IP_012,
      id: payload.id,
    });
    yield put({
      type: getDocsDetailSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getDocsDetailFailed.type,
    });
  }
}

function* watchGetDocsDetail() {
  yield takeLatest(getDocsDetailStart.type, getDocsDetailWork);
}

export default function* getNewsDetailSaga() {
  yield all([watchGetDocsDetail()]);
}
